<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent != null && localService.languageContent.table != undefined && source !== undefined && source !== null">
  <div class="banner center">
    <div *ngIf="localService.languageContent.request">
      <div class="row">
        <div class="col-md-6">
          <ngx-select [optionValueField]="'key'" [optionTextField]="'value'" [items]="source.statuses"
            [(ngModel)]="source.selected.v1" [allowClear]="true" [noAutoComplete]="true"
            title="{{localService.languageContent.request.select_status}}"
            placeholder="{{localService.languageContent.request.select_status}}" (select)="onLoad()"
            (remove)="onLoad()">
          </ngx-select>
        </div>
        <div class="col-md-6">
          <ngx-select [optionValueField]="'key'" [optionTextField]="'value'" [items]="getRequestTypes()"
            [(ngModel)]="source.selected.v2" [allowClear]="true" [noAutoComplete]="true"
            title="{{localService.languageContent.request.select_type}}"
            placeholder="{{localService.languageContent.request.select_type}}" (select)="onLoad()" (remove)="onLoad()">
          </ngx-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" style="text-align: right;color: indianred;">
          {{localService.languageContent.request.retry_info}}
        </div>
      </div>
    </div>
  </div>
  <div class="banner center" style="margin-top:10px;">
    <div class="row row_header freeze_col freeze_height">
      <div class="col-md-8">
        <div class="row">
          <div class="col-4">
            <span class="en">%</span>
          </div>
          <div class="col-4">
            {{localService.languageContent.table.status}}
          </div>
          <div class="col-4">
            {{localService.languageContent.table.type}}
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row">
          <div class="col-6">
            {{localService.languageContent.table.created_on}}
          </div>
          <div class="col-6">
            {{localService.languageContent.table.updated_on}}
          </div>
        </div>
      </div>
    </div>
    <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row styled_row freeze_col" *ngFor="let item of source.content.items">
        <div class="col-md-8">
          <div class="row">
            <div class="col-4" title="{{item.v7}}">
              <button class="button_icon button_icon_color" [disabled]="item.v8 == '0'" style="float: left;top:0px;"
                (click)="onAction(1,item.key)">repeat_one</button>
              <div class="en" style="float: left;">{{item.v5}}</div>
              <div style="float: right;">
                <span class="en">{{item.v4 | number: '1.2-2'}}</span>
                <button class="button_icon button_icon_color icon_adjust" (click)="onAction(2,item.v10)" [disabled]="!item.v10">account_tree</button>
              </div>
            </div>
            <div class="col-4">
              <button class="button_icon" *ngIf="item.v9 != ''" style="top:5px;color: red;"
                (click)="localService.showMessage(item.v9)">error_outline</button>
              {{onGetText(1,item.v1)}}
            </div>
            <div class="col-4">
              {{onGetText(2,item.v3)}}
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="col-6">
              <span class="en">{{item.v2 | localDate}}</span>
            </div>
            <div class="col-6">
              <span class="en">{{item.v6 | localDate}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-paging [paging]="source.content.paging" [IsShowDateRange]="true" (onPagingRefreshed)="onLoad()"
    [data]="source.selected"></app-paging>
</div>